import { Icon } from '@/src/components/ui';
import React from 'react';
import { StarRating } from '../../reviews/components/StarRating';

type Props = {
  average: number;
  total: number;
};

export const RatingStats = ({ average, total }: Props) => {
  if (total === 0) {
    return (
      <div className="flex flex-col gap-1">
        <span className="font-bold text-base">Not Rated</span>
        <span className="flex">
          {Array.from({ length: 5 }).map((_, index) => (
            <Icon key={index} name="star" className="text-black/20 size-4" />
          ))}
        </span>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <div className="flex gap-2 items-center">
        <span className="font-bold text-base">{average.toFixed(1)}</span>
        <span className="text-sm text-black/60 font-light">{`(${total})`}</span>
      </div>
      <div className="flex gap-2 items-center">
        <StarRating rating={average} className="size-4" />
      </div>
    </div>
  );
};
